import React from 'react';

import {
    Button
} from 'react-bootstrap';
import Swal from 'sweetalert2';

class MoreEberButton extends React.PureComponent {

    state = {
        
    };

    componentDidMount() {
        
    }

    goToEberHandler = () => {
        const object = {...this.props.object};
        if(object.option1 === undefined || !object.option1) {
            Swal.fire(`No Plan Details information`);    
            return
        }
        const planDetails = JSON.parse(object.option1);
        if(planDetails === undefined || !planDetails) {
            Swal.fire(`No Correct Format Plan Details information`);    
            return
        }
        const eberClientId = planDetails.plan_eber_clientid;
        if(eberClientId === undefined || !eberClientId) {
            Swal.fire(`No Eber Client information`);    
            return
        }
        this.props.history.push( '/eber/'+ eberClientId + "?controller=" + object.controller );
    }
    
    render () {
        return (
            <React.Fragment>
                <Button variant="success pull-right" onClick={this.goToEberHandler}>
                    <i className="fa fa-table"></i>
                    <span className="hidden-xs hidden-sm">&nbsp;Eber</span>
                </Button>
            </React.Fragment>
        )
    }
}

export default MoreEberButton;